import styled from '@emotion/styled';
import { setMargin } from '../../../helpers';

export const OptionalTag = styled.span`
  ${setMargin};
  display: inline-block;
  font-weight: 400 !important;
  color: ${({ theme }) => theme.colors.neutralMain};
`;

export const SectionContainer = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.neutralSurface};
  margin-block: 1rem;
  padding: 1.5rem;
  border-radius: 20px;
  min-width: 750px;
  ${({ theme }) => theme.media.tablet} {
    min-width: 500px;
  }
  ${({ theme }) => theme.media.mobile} {
    min-width: 0;
  }
`;

export const SectionFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-inline: 1rem;
`;
